function klevu_getParamValue(a) {
  if ((a = new RegExp("[?&]" + encodeURIComponent(a) + "=([^&]*)").exec(location.search))) {
    try {
      return decodeURIComponent(a[1].replace(/\+/g, " ")).replace(/(<([^>]+)>)/gi, "");
    } catch (b) {
      return unescape(a[1].replace(/\+/g, " ")).replace(/(<([^>]+)>)/gi, "");
    }
  }
}
var klevu_cmsTabEnabled = false,
  klevu_lpZeroResults = 0,
  klevu_storeLandingCurrency = "";
function klevu_setLandingPageResults(g) {
  var m = document,
    D = m.getElementById("kuResultsView"),
    y = g.result,
    F = g.meta,
    B = g.popularProducts,
    E = 0,
    c = 0,
    J = 0,
    d = 0,
    K = 0,
    Q = 0,
    p = m.getElementById("kuTotResults"),
    Z = 0,
    f = 100,
    T = "",
    t = "",
    R = "",
    U = "",
    e = "",
    u = "",
    L = "",
    z = "",
    h = "",
    I = "",
    o = "",
    X = "",
    a = "",
    H = "",
    M = "",
    x = "",
    A = "",
    ab = "",
    q = "",
    k,
    W,
    S = "",
    b = "",
    j = "",
    Y = "",
    aa = "",
    s = "",
    G = "",
    C = g.price,
    V = "",
    v = false,
    w = true,
    P,
    ac,
    N = 0,
    l = m.createElement("div"),
    r = "1",
    n = false;
  if (m.getElementById("kuProductContent")) {
    m.getElementById("kuProductContent").style.opacity = "";
  }
  E = Number(klevu_pagination.landingRecordsPerPage);
  c = Number(klevu_pagination.landingStartPosition);
  J = Number(klevu_pagination.totalLandingResultsFound);
  if (typeof F.totalResultsFound != "undefined" && F.totalResultsFound != null) {
    J = Number(F.totalResultsFound);
  }
  klevu_pagination.totalLandingResultsFound = J;
  if (J === 0) {
    if (klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1 && "undefined" !== typeof klevu_showPriceSlider && klevu_showPriceSlider) {
      v = true;
    } else {
      if (klevu_userOptions.selectedLandingRangeFilters && klevu_userOptions.selectedLandingRangeFilters.trim().length > 0) {
        n = true;
      } else {
        if (klevu_userOptions.cmsEnabled) {
          if (klevu_lpZeroResults !== 0) {
            m.getElementById("kuFilters").style.display = "none";
          } else {
            klevu_lpZeroResults = 1;
            m.getElementById("kuProductContent").innerHTML = '<div class="kuNoRecordFound" aria-live="assertive" role="alert" tabindex="0">' + klevu_uiLabels.noRecords + "</div>";
            if (!(klevu_pageCategory && klevu_searchedTerm === "*")) {
              klevu_changeKuTab("other");
            } else {
              klevu_lpZeroResults = 2;
              klevu_lpHandleNoResultsOrInvalidTermLength(klevu_uiLabels.noRecordsForCategory, null);
            }
          }
        } else {
          if ("undefined" !== typeof klevu_noResultsFoundUrl) {
            m.location = klevu_noResultsFoundUrl;
          } else {
            if (klevu_pageCategory && klevu_searchedTerm === "*") {
              klevu_lpHandleNoResultsOrInvalidTermLength(klevu_uiLabels.noRecordsForCategory, null);
            } else {
              klevu_lpHandleNoResultsOrInvalidTermLength(klevu_uiLabels.noRecords, B);
            }
          }
        }
        return;
      }
    }
  }
  if (E > 0 && !klevu_enableLandingAutoScroll) {
    Q = Math.floor(J / E);
    var O = J % E;
    if (O > 0) {
      Q += 1;
    }
    m.getElementById("totalPages").value = Q;
    if (c === 0) {
      klevu_showPaginationButtons(Q);
      r = klevu_getParamValue(klevu_productPageParam);
      if (klevu_addPageNumberToUrl && r && Q >= +r) {
        klevu_changePage(+r);
      }
    }
  }
  klevu_showTotalResultsText(p, J, -1);
  if ("undefined" !== typeof klevu_similarProductsFoundMsg && klevu_similarProductsFoundMsg) {
    klevu_commons.showSimilarProductsFoundMessage(klevu_searchedTerm, F, "kuOrQueryMessage");
  }
  if (klevu_enableLandingAutoScroll) {
    if (c === 0) {
      D.innerHTML = "";
      klevu_lpShowLoader();
    } else {
      w = false;
      klevu_lpAutoScrollLoader("show");
    }
  } else {
    D.innerHTML = "";
    klevu_lpShowLoader();
  }
  if (w) {
    x += '<ul id="kuLandingProductsListUl">';
  }
  for (Z = 0; Z < y.length; Z++) {
    T = "";
    t = "";
    R = "";
    U = "";
    e = "";
    u = "";
    L = "";
    z = "";
    V = "";
    I = "";
    o = "";
    X = "";
    h = "";
    H = "";
    M = "";
    q = "";
    a = "";
    A = "";
    ab = "";
    S = "";
    aa = "";
    s = "";
    G = "";
    b = "";
    j = "";
    Y = "";
    P = null;
    ac = null;
    N = Z + 1 + c;
    if (y[Z].id) {
      e = y[Z].id;
    }
    if (y[Z].name) {
      t = y[Z].name;
    }
    if (y[Z].metaDesc) {
      R = y[Z].metaDesc;
    }
    if (y[Z].desc) {
      R = y[Z].desc;
    }
    if (y[Z].shortDesc) {
      R = y[Z].shortDesc;
    }
    if (y[Z].shortDescription) {
      R = y[Z].shortDescription;
    }
    if (y[Z].salePrice) {
      u = y[Z].salePrice;
    }
    if (y[Z].price) {
      L = y[Z].price;
    }
    if (y[Z].url) {
      h = y[Z].url;
    }
    if (y[Z].image) {
      z = y[Z].image;
    }
    if (y[Z].imageUrl) {
      z = y[Z].imageUrl;
    }
    if (y[Z].brand) {
      U = y[Z].brand;
    }
    if (y[Z].currency) {
      V = y[Z].currency;
    }
    if (y[Z].startPrice) {
      A = y[Z].startPrice;
    }
    if (y[Z].toPrice) {
      ab = y[Z].toPrice;
    }
    if (y[Z].totalVariants) {
      a = y[Z].totalVariants;
    }
    if (y[Z].displayPrice) {
      X = y[Z].displayPrice;
    }
    if (y[Z].inStock) {
      M = y[Z].inStock;
    }
    if (y[Z].sku) {
      H = y[Z].sku;
    }
    if (y[Z].discount) {
      q = y[Z].discount;
    }
    if (y[Z].rating) {
      S = y[Z].rating;
    }
    if (y[Z].groupPrices) {
      aa = y[Z].groupPrices;
    }
    if (y[Z].category_collection) {
      s = y[Z].category_collection;
    }
    if (y[Z].lead_measurement) {
      G = y[Z].lead_measurement;
    }
    if (y[Z].manufacturer) {
      b = y[Z].manufacturer;
    }
    if (y[Z].deliveryInfo) {
      j = y[Z].deliveryInfo;
    }
    if (y[Z].deliveryInfoClass) {
      Y = y[Z].deliveryInfoClass;
    }
    T = R;
    l.innerHTML = T;
    T = l.textContent || l.innerText || "";
    klevu_storeLandingCurrency = V;
    if (T.length > f) {
      T = T.replace(/^(.{100}[^\s]*).*/, "$1") + " ...";
    }
    (k = T.lastIndexOf("<b")), (W = T.lastIndexOf("</b>"));
    if (k > W) {
      T = T.substring(0, k - 1);
    }
    P = {
      productCode: e,
      productImage: z,
      productBrand: U,
      productUrl: h,
      productName: t,
      productDescription: T,
      productPrice: L,
      salePrice: u,
      currency: V,
      priceToDisplay: X,
      startPrice: A,
      toPrice: ab,
      totalProductVariants: a,
      productSku: H,
      inStock: M,
      discount: q,
      rating: S,
      groupPrices: aa,
      categoryCollection: s,
      leadingDimension: G,
      manufacturer: b,
      deliveryInfo: j,
      deliveryInfoClass: Y,
      productPosition: N,
    };
    for (ac in y[Z]) {
      if (y[Z].hasOwnProperty(ac)) {
        P[ac] = y[Z][ac];
      }
    }
    x += klevu_displayLandingPageData(P);
    l.innerHTML = "";
  }
  if (w) {
    x += "</ul>";
    D.innerHTML += x;
  } else {
    m.getElementById("kuLandingProductsListUl").innerHTML += x;
  }
  klevu_lpHideLoader(true);
  if (klevu_enableLandingAutoScroll) {
    klevu_pagination.landingStartPosition = Number(klevu_pagination.landingStartPosition) + Number(klevu_pagination.landingRecordsPerPage);
  }
  klevu_commons.showBannerAdForGivenTerm(klevu_searchedTerm, "klp");
  if (v || n) {
    D.innerHTML = '<div class="kuNoRecordFound" aria-live="assertive" role="alert" tabindex="0">' + klevu_uiLabels.noRecordsForSelection + "</div>";
  }
  if (klevu_userOptions.fetchFilters) {
    klevu_landingFilters.showFilters(g.filters, g.ranges);
    if (C && C.min && C.max) {
      klevu_showPricingSlider(C, klevu_storeLandingCurrency);
    }
  }
  if ("function" === typeof klevu_afterLandingResultsLoaded) {
    klevu_afterLandingResultsLoaded(g.result);
  }
}
function klevu_setLandingPageCmsResults(b) {
  var A = document,
    u = A.getElementById("kuOtherContentView"),
    s = b.result,
    j = b.meta,
    p = b.popularProducts,
    h = 0,
    B = 0,
    n = 0,
    e = 0,
    k = 0,
    r = 0,
    x = A.getElementById("kuTotResults"),
    v = 0,
    c = 100,
    w = "",
    C = "",
    a = "",
    g = "",
    o,
    m,
    l = true,
    q = "",
    f = 0,
    y = "",
    z = A.createElement("div"),
    t;
  A.getElementById("kuOtherContent").style.opacity = "";
  h = Number(klevu_pagination.landingCmsRecordsPerPage);
  B = Number(klevu_pagination.landingCmsStartPosition);
  n = Number(klevu_pagination.totalLandingCmsResultsFound);
  if (typeof j.totalResultsFound != "undefined" && j.totalResultsFound != null) {
    n = Number(j.totalResultsFound);
  }
  klevu_pagination.totalLandingCmsResultsFound = n;
  if (n === 0) {
    if ("undefined" !== typeof klevu_noResultsFoundUrl) {
      A.location = klevu_noResultsFoundUrl;
    } else {
      if (klevu_lpZeroResults === 1) {
        klevu_lpZeroResults = 2;
        klevu_lpHandleNoResultsOrInvalidTermLength(klevu_uiLabels.noRecords, p);
      } else {
        if (klevu_lpZeroResults === 0) {
          A.getElementById("kuOtherContent").innerHTML = '<div class="kuNoRecordFound" aria-live="assertive" role="alert" tabindex="0">' + klevu_uiLabels.noRecords + "</div>";
        }
      }
      return;
    }
  }
  if (h > 0 && !klevu_enableLandingAutoScroll) {
    r = Math.floor(n / h);
    var d = n % h;
    if (d > 0) {
      r += 1;
    }
    A.getElementById("totalPages").value = r;
    if (B === 0) {
      klevu_showPaginationButtons(r);
    }
  }
  klevu_showTotalResultsText(x, -1, n);
  if ("undefined" !== typeof klevu_similarProductsFoundMsg && klevu_similarProductsFoundMsg) {
    klevu_commons.showSimilarProductsFoundMessage(klevu_searchedTerm, j, "kuOrQueryMessage");
  }
  if (klevu_enableLandingAutoScroll) {
    if (B === 0) {
      u.innerHTML = "";
      klevu_lpShowLoader();
    } else {
      l = false;
      klevu_lpAutoScrollLoader("show");
    }
  } else {
    u.innerHTML = "";
    klevu_lpShowLoader();
  }
  if (l) {
    q += '<ul id="kuLandingCmsListUl">';
  }
  for (v = 0; v < s.length; v++) {
    w = "";
    C = "";
    a = "";
    g = "";
    f = 1 + v + B;
    y = "";
    if (s[v].id) {
      a = s[v].id;
    }
    if (s[v].name) {
      C = s[v].name;
    }
    if (s[v].metaDesc) {
      w = s[v].metaDesc;
    }
    if (s[v].desc) {
      w = s[v].desc;
    }
    if (s[v].shortDesc) {
      w = s[v].shortDesc;
    }
    if (s[v].shortDescription) {
      w = s[v].shortDescription;
    }
    if (s[v].url) {
      g = s[v].url;
    }
    if (s[v].imageUrl) {
      y = s[v].imageUrl;
    }
    z.innerHTML = w;
    w = z.textContent || z.innerText || "";
    if (("undefined" === typeof klevu_truncateDescription || ("undefined" !== typeof klevu_truncateDescription && klevu_truncateDescription)) && w.length > c) {
      w = w.replace(/^(.{100}[^\s]*).*/, "$1") + " ...";
    }
    (o = w.lastIndexOf("<b")), (m = w.lastIndexOf("</b>"));
    if (o > m) {
      w = w.substring(0, o - 1);
    }
    t = { contentCode: a, contentUrl: g, contentTitle: C, contentDescription: w, contentPosition: f, contentImage: y };
    for (objectKey in s[v]) {
      if (s[v].hasOwnProperty(objectKey)) {
        t[objectKey] = s[v][objectKey];
      }
    }
    q += klevu_displayLandingPageCmsData(t);
    z.innerHTML = "";
  }
  if (l) {
    q += "</ul>";
    u.innerHTML += q;
  } else {
    A.getElementById("kuLandingCmsListUl").innerHTML += q;
  }
  klevu_lpHideLoader(true);
  if (klevu_enableLandingAutoScroll) {
    klevu_pagination.landingCmsStartPosition = Number(klevu_pagination.landingCmsStartPosition) + Number(klevu_pagination.landingCmsRecordsPerPage);
  }
  if (klevu_userOptions.fetchFilters) {
    klevu_landingCmsFilters.showFilters(b.filters);
  }
  if ("function" === typeof klevu_afterLandingCmsResultsLoaded) {
    klevu_afterLandingCmsResultsLoaded();
  }
}
function klevu_lpShowLoader() {
  var a = document;
  if (a.getElementById("loader")) {
    a.getElementById("loader").style.display = "block";
    if (a.getElementById("kuProListing")) {
      a.getElementById("kuProListing").style.display = "none";
    }
  }
}
function klevu_lpHideLoader(a) {
  var b = document;
  if (b.getElementById("loader")) {
    b.getElementById("loader").style.display = "none";
    if (a) {
      if (b.getElementById("kuProListing")) {
        b.getElementById("kuProListing").style.display = "block";
      }
    }
  }
  if (b.getElementById("ku-lp-loader")) {
    b.getElementById("ku-lp-loader").style.display = "none";
    if (a) {
      if (b.getElementById("kuProListing")) {
        b.getElementById("kuProListing").style.display = "block";
      }
    }
  }
  if (klevu_enableLandingAutoScroll) {
    klevu_lpAutoScrollLoader("hide");
  }
  if (klevu_layout && klevu_layout.hideLoader) {
    klevu_layout.hideLoader();
  }
}
function klevu_lpHandleNoResultsOrInvalidTermLength(c, b) {
  var a = document;
  if (!klevu_userOptions.cmsEnabled || (klevu_userOptions.cmsEnabled && klevu_lpZeroResults === 2)) {
    if (b !== null) {
      a.getElementById("kuNoRecordFound").innerHTML = klevu_displayNoResultData(klevu_commons.getNoResultsData(c, b));
    } else {
      a.getElementById("kuNoRecordFound").innerHTML = c;
    }
    a.getElementById("kuNoRecordFound").style.display = "block";
    a.getElementById("kuFilters").style.display = "none";
    a.getElementById("kuResultListBlock").style.display = "none";
    klevu_lpHideLoader(false);
  }
}
function klevu_getPageElementAttributes(a) {
  if (klevu_addPageNumberToUrl) {
    return 'href="?pPgNo=' + a + '" onclick="klevu_changePage(' + a + ', event);"';
  } else {
    return 'href="javascript:klevu_changePage(' + a + ');"';
  }
}
function klevu_showPaginationButtons(b) {
  var g = document,
    c = g.getElementById("kuPagination1"),
    a = g.getElementById("kuPagination2"),
    f = "",
    e = false,
    d = 0;
  if (b <= 3) {
    e = false;
  } else {
    e = true;
  }
  for (d = 1; d <= 3 && d <= b; d++) {
    if (d === 1) {
      f += '<a href="javascript:void(0);" class="kuCurrent" target="_self">' + d + "</a>&nbsp;";
    } else {
      f += "<a " + klevu_getPageElementAttributes(d) + ' target="_self">' + d + "</a>&nbsp;";
    }
  }
  if (e) {
    f += "...&nbsp;";
  }
  if (b > 1) {
    f += "<a " + klevu_getPageElementAttributes(2) + ' title="' + klevu_uiLabels.nextPage + '" target="_self">&gt;</a>&nbsp;<a ' + klevu_getPageElementAttributes(b) + ' title="' + klevu_uiLabels.lastPage + '" target="_self">&gt;&gt;</a>';
  }
  if (klevu_cmsTabEnabled) {
    g.getElementById("kuPagination3").innerHTML = f;
    g.getElementById("kuPagination4").innerHTML = f;
    klevu_pagination.landingCmsStartPosition = 0;
  } else {
    c.innerHTML = f;
    a.innerHTML = f;
    klevu_pagination.landingStartPosition = 0;
  }
}
function klevu_changePage(a, b) {
  var m = document,
    f = m.getElementById("kuPagination1"),
    e = m.getElementById("kuPagination2"),
    c = "",
    h = false,
    j = 0,
    k = 0,
    l = a + 1,
    g = a - 1,
    d = Number(m.getElementById("totalPages").value);
  if (a < 1 || a > d) {
    return;
  }
  if (a != 1) {
    c +=
      "<a " +
      klevu_getPageElementAttributes(1) +
      ' title="' +
      klevu_uiLabels.firstPage +
      '" target="_self">&lt;&lt;</a>&nbsp;<a ' +
      klevu_getPageElementAttributes(a - 1) +
      ' title="' +
      klevu_uiLabels.prevPage +
      '" target="_self">&lt;</a>&nbsp;';
  }
  if (d <= 3) {
    h = false;
  } else {
    if (a === d - 1 || a === d) {
      h = false;
    } else {
      h = true;
    }
  }
  if (a === d) {
    g = a - 2;
    l = a;
  }
  if (a === 1) {
    g = 1;
    l = 3;
  }
  if (g < 1) {
    g = 1;
  }
  for (j = g; j <= l && j <= d; j++) {
    if (j === a) {
      c += '<a href="javascript:void(0);" class="kuCurrent" target="_self">' + j + "</a>&nbsp;";
    } else {
      c += "<a " + klevu_getPageElementAttributes(j) + ' target="_self">' + j + "</a>&nbsp;";
    }
  }
  if (h) {
    c += "...&nbsp;";
  }
  if (a != d) {
    c +=
      "<a " + klevu_getPageElementAttributes(a + 1) + ' title="' + klevu_uiLabels.nextPage + '" target="_self">&gt;</a>&nbsp;<a ' + klevu_getPageElementAttributes(d) + ' title="' + klevu_uiLabels.lastPage + '" target="_self">&gt;&gt;</a>';
  }
  if (b) {
    b.preventDefault();
  }
  if (klevu_cmsTabEnabled) {
    m.getElementById("kuPagination3").innerHTML = c;
    m.getElementById("kuPagination4").innerHTML = c;
    k = (a - 1) * Number(klevu_pagination.landingCmsRecordsPerPage);
    klevu_pagination.landingCmsStartPosition = k;
    klevu_search.fetchCmsResults(m.getElementById("searchedKeyword").value, "klp");
  } else {
    f.innerHTML = c;
    e.innerHTML = c;
    k = (a - 1) * Number(klevu_pagination.landingRecordsPerPage);
    klevu_pagination.landingStartPosition = k;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (klevu_addPageNumberToUrl) {
      klevu_commons.addPageNumberToPageUrl(a, klevu_productPageParam);
    }
    klevu_search.fetchResults(m.getElementById("searchedKeyword").value, "klp");
  }
}
function klevu_showTotalResultsText(a, e, g) {
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.showTotalResultsText) {
    klevu_uc.showTotalResultsText(klevu_pagination, e, g);
    return;
  }
  var d = "undefined" !== typeof klevu_pageCategory ? false : klevu_userOptions.cmsEnabled;
  if (a) {
    if (d) {
      var i = klevu_uiLabels.products.indexOf("#") === -1 ? "<strong>" + e + "</strong> " + klevu_uiLabels.products : klevu_uiLabels.products.replace("#", "<strong>" + e + "</strong> "),
        j = klevu_uiLabels.otherContent.indexOf("#") === -1 ? "<strong>" + g + "</strong> " + klevu_uiLabels.otherContent : klevu_uiLabels.otherContent.replace("#", "<strong>" + g + "</strong> "),
        h = document,
        b = "kuTabSelected",
        f = "kuTabSelected";
      if (e === -1) {
        f = "";
        if (h.getElementById("kuProductTab")) {
          i = h.getElementById("kuProductTab").innerHTML;
        } else {
          i = klevu_uiLabels.products.replace("#", "");
        }
      } else {
        if (e === 0) {
          j = klevu_uiLabels.otherContent.indexOf("#") === -1 ? "<strong>" + e + "</strong> " + klevu_uiLabels.otherContent : klevu_uiLabels.otherContent.replace("#", "<strong>" + e + "</strong> ");
        }
      }
      if (g === -1) {
        b = "";
        if (h.getElementById("kuOtherTab")) {
          j = h.getElementById("kuOtherTab").innerHTML;
        } else {
          j = klevu_uiLabels.otherContent.replace("#", "");
        }
      } else {
        if (g === 0) {
          j = klevu_uiLabels.otherContent.indexOf("#") === -1 ? "<strong>" + g + "</strong> " + klevu_uiLabels.otherContent : klevu_uiLabels.otherContent.replace("#", "<strong>" + g + "</strong> ");
        }
      }
      a.innerHTML =
        '<div class="kuTabs" id="kuTabs"><a id="kuProductTab" class="' +
        f +
        '"  onclick="klevu_changeKuTab( \'product\' );" href="#" target="_self">' +
        i +
        '</a><a id="kuOtherTab" class="' +
        b +
        '"  onclick="klevu_changeKuTab( \'other\' );" href="#" target="_self">' +
        j +
        "</a></div>";
      a.style.display = "block";
      a.className = "kuTotalResultsTab";
    } else {
      if (klevu_uiLabels.resultsFound.indexOf("#") === -1) {
        a.innerHTML = "<strong>" + e + "</strong> " + klevu_uiLabels.resultsFound;
      } else {
        var c = klevu_searchedTerm;
        if (c === "*" && "undefined" !== typeof klevu_pageCategory && klevu_pageCategory) {
          c = klevu_pageCategory.split(/[;;]+/).pop();
        }
        a.innerHTML = klevu_uiLabels.resultsFound.replace("#", "<strong>" + e + "</strong> ").replace(":A", "'" + c + "'");
      }
      a.className = "kuTotResults";
    }
  }
}
function klevu_changeSortingOptionsForLandigPage(a) {
  klevu_userOptions.sortingLandingValue = a;
  klevu_pagination.landingStartPosition = 0;
  klevu_search.fetchResults(document.getElementById("searchedKeyword").value, "klp");
}
function klevu_changeItemsPerPage(b) {
  var a = document;
  a.getElementById("noOfRecords1").value = b;
  a.getElementById("noOfRecords2").value = b;
  klevu_pagination.landingRecordsPerPage = typeof b === "string" ? b.trim() : b;
  klevu_pagination.landingStartPosition = 0;
  klevu_search.fetchResults(a.getElementById("searchedKeyword").value, "klp");
}
function klevu_changeCmsItemsPerPage(b) {
  var a = document;
  a.getElementById("noOfRecords3").value = b;
  a.getElementById("noOfRecords4").value = b;
  klevu_pagination.landingCmsRecordsPerPage = typeof b === "string" ? b.trim() : b;
  klevu_pagination.landingCmsStartPosition = 0;
  klevu_search.fetchCmsResults(a.getElementById("searchedKeyword").value, "klp");
}
var klevu_landingProductElements = {
  showPrices: function (c, b) {
    var d = "",
      a = c.additionalFlags;
    if (a && a.is_price_hidden) {
      d += a.price_hidden_label ? a.price_hidden_label : "";
    } else {
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        d += klevu_commons.showOriginalAndSalePrices("LANDING", c, b, "kuSalePrice kuSpecialPrice");
      } else {
        d += klevu_commons.showProductPrices("LANDING", c, b, "kuSalePrice kuSpecialPrice");
      }
    }
    return d;
  },
  showRating: function (c) {
    var d = "",
      b = c.additionalFlags,
      a = 0;
    if (c.rating.trim().length > 0 && !isNaN(Number(c.rating)) && Number(c.rating) <= 5 && Number(c.rating) >= 0) {
      a = 20 * Number(c.rating);
      d += '<div><div class="kuStarsSmall"><div class="kuRating" style="width:' + a + '%;"></div></div>';
      if (b && b.rating_count) {
        d += "&nbsp;<span>(" + b.rating_count + ")</span>";
      }
      d += "</div>";
    }
    return d;
  },
  showAddtocart: function (c) {
    try {
      var g = "",
        b = c.additionalFlags,
        f = klevu_userOptions.addToCartButton,
        a = c.totalProductVariants ? +c.totalProductVariants : 0,
        h = false;
      if (b) {
        if (b.preorder_only) {
          h = true;
          f = klevu_userOptions.preorderButton;
        }
        if (b.purchasing_disabled) {
          if (!h) {
            return "";
          }
        }
      }
      if (!(c.isCustomOptionsAvailable && c.isCustomOptionsAvailable === "yes") && a === 0 && !h) {
        g +=
          '<div class="kuAddtocart" id="kuAddtocart-' +
          escape(c.productCode) +
          '"><label for="klevu-qty-' +
          escape(c.productCode) +
          '" style="display:none;">&nbsp;</label><input tabindex="0" type="text" name="klevu-qty" id="klevu-qty-' +
          escape(c.productCode) +
          '" placeholder="' +
          klevu_uiLabels.addToCartPlaceholder +
          '"/><a href="javascript:klevu_lpSendProductToCart(\'' +
          escape(c.productCode) +
          "', '" +
          escape(c.productUrl) +
          "', 'klevu-qty-" +
          escape(c.productCode) +
          '\');" class="kuAddtocartBtn" target="_self">' +
          f +
          "</a></div>";
      } else {
        g += '<div class="kuAddtocart" id="kuAddtocart-' + escape(c.productCode) + '"><a href="' + c.productUrl.replace(/"/g, "%22") + '" class="kuAddtocartBtn" target="_self">' + f + "</a></div>";
      }
      g += '<div class="klevu-clearboth-listview"></div>';
    } catch (d) {}
    return g;
  },
};
function klevu_displayLandingPageData(b) {
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.showLandingPageData) {
    return klevu_uc.showLandingPageData(b);
  }
  var s = "",
    n = "",
    k = "",
    A = false,
    D = "kuSalePrice",
    h,
    y,
    z = false,
    r = "",
    q = document.getElementById("searchedKeyword").value,
    v = "",
    t = "",
    C = 0,
    B = 0,
    w,
    a,
    m,
    G,
    u,
    f = 0,
    p = false,
    d = "",
    o = 5,
    l = true,
    g = "",
    x,
    E = document.createElement("div"),
    c = b.additionalDataToReturn ? JSON.parse(b.additionalDataToReturn) : false;
  b = klevu_productCustomizations(b);
  b.additionalFlags = c;
  if (b.productImage.trim().length === 0) {
    b.productImage = klevu_userOptions.noImageUrl;
  }
  if (klevu_userOptions.openProductClicksInNewWindow) {
    r = ' target="_blank"';
  } else {
    r = ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"';
  }
  v =
    "{data: {code: '" +
    escape(b.productCode) +
    "',url: '" +
    escape(b.productUrl) +
    "',name: '" +
    escape(b.productName) +
    "',salePrice: '" +
    escape(b.salePrice) +
    "',rating: '" +
    escape(b.rating) +
    "',position: " +
    b.productPosition +
    ",category: '" +
    escape(b.category) +
    "',sku: '" +
    escape(b.sku) +
    "'},apiKey: null,keywordsLP: '" +
    escape(q) +
    "'}";
  if (klevu_commons.isMobileDevice()) {
    t = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + v + ');" target="_self">';
  } else {
    t = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + v + ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + v + ', klevu_analytics.trackClickedProduct);" ' + r + ">";
  }
  try {
    s += "<li>";
    s += '<div class="klevuImgWrap">';
    s += "<a  onfocus=\"klevu_eventHandler.handleProductFocusEvent('kuAddtocart-" + escape(b.productCode) + '\', event);"href="' + b.productUrl.replace(/"/g, "%22") + '" ';
    if (klevu_userOptions.showRolloverImage && b.imageHover) {
      s +=
        " onmouseleave = \"klevu_commons.updateProductThumbnailImage('" +
        escape(b.productImage) +
        "', 'klevuProductImage-" +
        b.id +
        "');\"  onmouseenter = \"klevu_commons.updateProductThumbnailImage('" +
        escape(b.imageHover) +
        "', 'klevuProductImage-" +
        b.id +
        "');\" ";
    }
    E.innerHTML = b.productName;
    x = E.textContent || E.innerText || "";
    s += " " + t + '<img id= "klevuProductImage-' + b.id + '" src="' + b.productImage + '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(x) + '"/>';
    s += "</a></div>";
    if (klevu_userOptions.showProductSwatches && b.swatches && b.swatches.swatch && b.swatches.swatch.length > 0) {
      o = b.swatches.swatch.length > o ? o : b.swatches.swatch.length;
      for (C = 0; C < o; C++) {
        w = b.swatches.swatch[C];
        if (w.image) {
          p = true;
          if (w.swatchImage && w.swatchImage.indexOf("#") === 0) {
            u = w.swatchImage.split(";");
            w.swatchImage = "";
          } else {
            u = w.color.replace(/ /g, "").replace(/-/g, "");
          }
          l = true;
          if ("object" === typeof u) {
            for (B = 0; B < u.length; B++) {
              if (u[B] && !klevu_commons.isValidCSSColor(u[B])) {
                l = false;
                break;
              }
            }
          } else {
            if (!w.swatchImage && !klevu_commons.isValidCSSColor(u)) {
              l = false;
            }
            if (!klevu_commons.isValidCSSColor(u)) {
              u = "";
            }
          }
          if (!l) {
            d += '<div class="klevuSwatchItem klevuDefaultSwatch">';
          } else {
            d += '<div class="klevuSwatchItem">';
          }
          m = "klevu_commons.updateProductThumbnailImage('" + escape(w.image) + "', 'klevuProductImage-" + b.id + "');";
          G = "klevu_commons.updateProductThumbnailImage('" + escape(b.productImage) + "', 'klevuProductImage-" + b.id + "');";
          if (klevu_commons.isMobileDevice()) {
            a = ' onclick = "' + m + '" ';
          } else {
            a = ' onmouseleave = "' + G + '" onmouseenter = "' + m + '" onfocus = "' + m + '" onblur = "' + G + '" ';
          }
          d += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + a;
          if ("object" === typeof u) {
            var H = 100 / u.length;
            g = "linear-gradient(-45deg,";
            for (B = 0; B < u.length; B++) {
              if (B === 0) {
                g += " ";
              } else {
                g += ", ";
              }
              g += u[B] + " " + H * B + "%";
              g += ", " + u[B] + " " + H * (B + 1) + "%";
            }
            g += " );";
            d += ' style = "background-image: ' + g + "background-image: -webkit-" + g + "background-image: -moz-" + g + "background-image: -o-" + g + "background-image: -ms-" + g + '" title="' + w.color + '">';
          } else {
            d += ' style = "background-color:' + u + "; background-image:url('" + w.swatchImage + '\');" title="' + w.color + '" target="_self">';
          }
          d += "</a></div>";
        } else {
          f += 1;
        }
      }
      if (b.swatches.swatch.length > o) {
        f += b.swatches.swatch.length - o;
      }
      if (!p) {
        d = '<div class="klevuSwatches" style="display:none;">' + d;
      } else {
        d = '<div class="klevuSwatches">' + d;
      }
      f += b.swatches.numberOfAdditionalVariants ? +b.swatches.numberOfAdditionalVariants : 0;
      if (f > 0 && p) {
        d += '<div class = "klevuSwatchItem klevuSwatchMore"><a href = "' + b.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + t + '<span class = "klevuSwatchMoreText">+' + f + "</span></a></div>";
      }
      d += "</div>";
      s += d;
    }
  } catch (F) {}
  if ("undefined" !== typeof klevu_showDiscountBadge && klevu_showDiscountBadge && b.discount != "" && b.discount != "0" && b.discount != "0.0") {
    if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
      s += '<div class="kuDiscountBadge">' + klevu_uiLabels.discountBadgeText + " " + Number(b.discount).toFixed(0) + "%</div>";
    } else {
      s += '<div class="kuDiscountBadge">' + klevu_uiLabels.discountBadgeText.replace("#", Number(b.discount).toFixed(0) + "%") + "</div>";
    }
  }
  s += '<div class="kuNameDesc">';
  s += '<div class="kuName"><a tabindex="-1" href="' + b.productUrl.replace(/"/g, "%22") + '" ' + t;
  s += b.productName + "</a></div>";
  s += '<div class="kuDesc">' + b.productDescription + "</div>";
  s += klevu_landingProductElements.showRating(b);
  s += "</div>";
  s += '<div class="kuPrice">';
  if (klevu_showPrices) {
    s += klevu_landingProductElements.showPrices(b, D);
  }
  if (klevu_userOptions.vatCaption.trim().length > 0) {
    console.log(klevu_userOptions.vatCaption);
    s += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ")</div>";
  }
  if (b.totalProductVariants && b.totalProductVariants != "0" && !p) {
    if (klevu_uiLabels.variants.indexOf("#") === -1) {
      s += '<div class="klevu-variants">+' + b.totalProductVariants + " " + klevu_uiLabels.variants + "</div>";
    } else {
      s += '<div class="klevu-variants">' + klevu_uiLabels.variants.replace("#", b.totalProductVariants) + "</div>";
    }
  }
  if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
    if (b.inStock && b.inStock === "no") {
      s += '<div class="klevu-out-of-stock">' + klevu_userOptions.outOfStockCaption + "</div>";
    }
  }
  s += "</div>";
  if (klevu_commons.showAddToCartButton(b.inStock, b.hideAddToCart)) {
    s += klevu_landingProductElements.showAddtocart(b);
  }
  s += '<div class="kuClearLeft"></div>';
  s += "</li>";
  return s;
}
function klevu_getPriceDivs(b, d, e, a) {
  if (b === "ORIG") {
    return '<div class="kuOrigPrice">' + d + "</div>";
  }
  if (b === "SALE") {
    var c = "";
    c += '<div class="' + a + '">';
    if (e !== "") {
      c += '<span class="priceGreyText">' + e + "</span> ";
    }
    c += d + "</div>";
    return c;
  }
}
function klevu_lpSendProductToCart(a, c) {
  var b = 1;
  if (arguments.length > 2) {
    if (document.getElementById(arguments[2])) {
      b = Number(document.getElementById(arguments[2]).value);
      if (b <= 0) {
        b = 1;
      }
    }
  }
  klevu_addtocart(a, c, b);
}
function klevu_displayLandingPageCmsData(c) {
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.showLandingPageCmsData) {
    return klevu_uc.showLandingPageCmsData(c);
  }
  var e = "",
    a = "",
    b = document.getElementById("searchedKeyword").value,
    d = "";
  if (klevu_userOptions.openProductClicksInNewWindow) {
    a = ' target="_blank"';
  } else {
    a = ' onclick="klevu_analytics.stopClickDefault( event );"';
  }
  d =
    "{data: {code: '" +
    escape(c.contentCode) +
    "',url: '" +
    escape(c.contentUrl) +
    "',name: '" +
    escape(c.contentTitle) +
    "',position: " +
    c.contentPosition +
    "},apiKey: '" +
    klevu_cmsApiKey +
    "',keywordsLP: '" +
    escape(b) +
    "',forCms: true}";
  e += "<li>";
  e += '<div class="kuNameDesc">';
  e += '<div class="kuName"><a href="' + c.contentUrl + '" target="_blank" ';
  if (klevu_commons.isMobileDevice()) {
    e += ' onclick="return klevu_analytics.trackClickedProduct(event, ' + d + ');" >';
  } else {
    e += ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + d + ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + d + ', klevu_analytics.trackClickedProduct);" ' + a + ">";
  }
  e += c.contentTitle + "</a></div>";
  e += '<div class="kuDesc">' + c.contentDescription + "</div>";
  e += "</div>";
  e += '</div><div class="kuClearLeft"></div>';
  e += "</li>";
  return e;
}
function klevu_showPricingSlider(r, l) {
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.showPricingSlider) {
    return klevu_uc.showPricingSlider(r, l);
  }
  var p = document,
    j = p.getElementById("ku-price-range"),
    l = klevu_commons.replaceCurrencyWithItsSymbol(l, l),
    g = Math.floor(Number(r.min)),
    m = Math.ceil(Number(r.max)),
    b = r.start ? Math.floor(Number(r.start)) : g,
    f = r.end ? Math.floor(Number(r.end)) : m,
    i = p.getElementById("kuFilters"),
    q = klevu_userOptions.priceSliderOption,
    o = "",
    a = -1,
    n = { input: "ku", slider: { main: "ku-price-range", start: "ku-from-price", end: "ku-to-price" } };
  if (klevu_showPrices) {
    if (j === null) {
      if (klevu_landingFilters.addRangeSlider) {
        i.appendChild(klevu_landingFilters.addRangeSlider("Price-Range", "klevu_price", klevu_translateFilterLabel("PRICE RANGE").toUpperCase(), n));
      } else {
        i.innerHTML += klevu_landingFilters.displayPricingSlider();
      }
      j = p.getElementById("ku-price-range");
      if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
        o = " kuMulticheck";
      }
      i.className = "kuFilters kuPriceSliderActive" + o;
    }
    b = b < g ? g : b;
    f = f > m ? m : f;
    q.start = [b, f];
    q.range = { min: g, max: m };
    q.format = {
      to: function (t) {
        var e = klevu_userOptions.priceFormatter,
          s = t.formatMoneyForKlevu(0, "", e.thousandSeparator, e.decimalSeparator);
        if (klevu_currenciesAppendedAtEnd.indexOf(l) !== -1) {
          return s + "&nbsp;" + l;
        } else {
          return l + "&nbsp;" + s;
        }
      },
      from: function (e) {
        return klevu_commons.removePriceFormatting(e, l);
      },
    };
    if ("undefined" !== typeof klevu_current_version && klevu_current_version) {
      a = klevu_commons.compareVersionNumbers(klevu_current_version, "2.0.2");
      if (!isNaN(a) && a >= 0) {
        q.cssPrefix = "kuPS-";
      }
      a = klevu_commons.compareVersionNumbers(klevu_current_version, "2.0.0");
      if (!isNaN(a) && a < 0) {
        a = klevu_commons.compareVersionNumbers(klevu_current_version, "1.2.5");
        if (!isNaN(a) && a >= 0) {
          q.cssPrefix = "kuPS-";
        }
      }
    }
    if ("undefined" !== typeof klevu_shopifyStore && klevu_shopifyStore) {
      q.cssPrefix = "kuPS-";
    }
    try {
      klevuPriceSlider.create(j, q);
    } catch (k) {}
    var h = document.getElementById("ku-from-price"),
      d = document.getElementById("ku-to-price"),
      c = "";
    try {
      j.klevuPriceSlider.on("update", function (e, s) {
        e[0] = klevu_commons.removePriceFormatting(e[0], l);
        e[1] = klevu_commons.removePriceFormatting(e[1], l);
        selectedFilters = klevu_userOptions.selectedLandingFilters;
        c = "klevu_price:" + e[0] + " - " + e[1];
        if (!(e[0] == b && e[1] == f) && b >= g && f <= m) {
          clearTimeout(klevu_psTimer);
          klevu_psTimer = setTimeout(function () {
            if (selectedFilters === "") {
              selectedFilters = c;
            } else {
              if (selectedFilters.indexOf("klevu_price") !== -1) {
                selectedFilters = selectedFilters.replace(/klevu_price:[0-9.\- ]*;*/, c);
              } else {
                selectedFilters += ";;" + c;
              }
            }
            klevu_userOptions.selectedLandingFilters = selectedFilters;
            if (klevu_addSelectedFiltersToUrl) {
              klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingFilters, klevu_productFilterParam);
            }
            klevu_pagination.landingStartPosition = 0;
            if ("undefined" === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters) {
              document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
            if (p.getElementById("kuProductContent")) {
              p.getElementById("kuProductContent").style.opacity = "0.3";
            }
            klevu_search.fetchResults(p.getElementById("searchedKeyword").value, "klp");
          }, 500);
        }
      });
    } catch (k) {
      p.getElementById("kuFilterBox-Price-Range").style.display = "none";
    }
  }
}
var klevuLandingFilterTxt = "";
var klevu_landingFilters = {
  loadingFiltersFor: "search-query",
  lastSelectedFilters: "",
  showFilters: function (a) {
    var g = document.getElementById("kuFilters"),
      h,
      l,
      e = 0,
      c = 0,
      b = new Array(),
      o = "",
      n = klevu_commons.isMobileDevice() ? document.getElementById("kuFilterRefineMobile") : document.getElementById("klevuNarrowByLabel");
    klevuLandingFilterTxt = "";
    g.innerHTML = "";
    if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
      o = " kuMulticheck";
    }
    if (a && a.length > 0) {
      g.className = "kuFilters" + o;
      for (h = 0, l = a.length; h < l; h++) {
        if (a[h].key === "Price Range" && !klevu_showPrices) {
          continue;
        }
        b[e] = klevu_landingFilters.displayFiltersData(a[h]);
        e++;
      }
      g.innerHTML = klevuLandingFilterTxt;
      if ("undefined" !== typeof n && n) {
        if (klevuLandingFilterTxt.trim().length === 0) {
          n.style.display = "none";
        } else {
          n.style.display = "block";
        }
      }
      for (h = 0, l = b.length; h < l; h++) {
        if (b[h] && b[h].trim() != "") {
          document.getElementById(b[h]).style.height = "auto";
        }
      }
      e = 0;
      for (c = 0, l = a.length; c < l; c++) {
        var p = a[c].key.replace(" ", "_"),
          f = a[c].options;
        for (var h = 0; h < f.length; h++) {
          var d = f[h].isSelected,
            m = h + p + "~text";
          if (d.trim() === "true") {
            klevu_landingFilters.showSelectedFilter(m, f[h].name, e, a[c].label);
            e++;
          }
        }
      }
      if ("undefined" !== typeof klevu_showPriceSlider && klevu_showPriceSlider && klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
        klevu_landingFilters.showSelectedFilter(null, klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0], e, null, "Price-Range");
        e++;
      }
      if (e === 0) {
        klevu_landingFilters.showSelectedFilter(null, null, -1);
      }
      g.style.display = "none";
      g.offsetHeight;
      g.style.display = "block";
      if (document.getElementById("kuFilterRefineMobile") && klevu_commons.isMobileDevice() && (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768)) {
        if (klevu_landingFilters.lastSelectedFilters === klevu_userOptions.selectedLandingFilters) {
          klevu_landingFilters.showFiltersOnMobile(false);
        } else {
          klevu_landingFilters.showFiltersOnMobile(!(e === 0));
        }
        klevu_landingFilters.lastSelectedFilters = klevu_userOptions.selectedLandingFilters;
      }
    } else {
      g.className = "kuFilters disableKuFilter" + o;
    }
  },
  displayFiltersData: function (g) {
    if (g) {
      var t = klevu_translateFilterLabel(g.label).toUpperCase(),
        o = false,
        h = false,
        e = "",
        a = g.options,
        u = g.key.replace(" ", "_"),
        f,
        s = false,
        q = false,
        j,
        b = "kuHover";
      if (g.label.toLowerCase() === "price range") {
        o = true;
      }
      if (g.label === "MSRP") {
        h = true;
      }
      if (g.key === "inStock") {
        s = true;
      }
      if (klevu_commons.isMobileDevice()) {
        b = "";
      }
      if (a.length > 6) {
        e += '<div class="kuFilterBox ' + b + '" id="kuFilterBox-' + u + '">';
      } else {
        e += '<div class="kuFilterBox ' + b + '" style="height:auto;" id="kuFilterBox-' + u + '">';
      }
      e +=
        '<div class="kuFilterHead kuCollapse" id="kuFilterHead-' +
        u +
        '" onclick="klevu_landingFilters.collapseExpand( \'kuFilterHead-' +
        u +
        "', 'kuFilterNames-" +
        u +
        "', 'kuShowOpt-" +
        u +
        "', 'kuHideOpt-" +
        u +
        "', 'kuFilterBox-" +
        u +
        "' );\">" +
        t +
        '</div><div class="kuFilterNames kuFilterNames1" id="kuFilterNames-' +
        u +
        '"><ul>';
      for (var n = 0, p = a.length; n < p; n++) {
        var k = a[n].isSelected,
          d = n + u + "~text",
          c = "",
          r = "kuFilterTotal",
          l = a[n].count,
          m = "klevu_landingFilters.sendQuery('" + d + "', true );";
        if (k.trim() === "true") {
          c = "kuSelected";
          r = "kuFilterCancel";
          if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
            l = a[n].count;
            q = true;
          } else {
            l = "X";
          }
          m = "klevu_landingFilters.cancelFilter('" + d + "'); ";
        }
        f = a[n].name;
        if (o) {
          f = klevu_commons.replaceCurrencyWithItsSymbol(f, klevu_storeLandingCurrency);
          j = f;
          f = "";
        } else {
          if (klevu_userOptions.truncateFilterLabel) {
            j = f.trunc(18);
          } else {
            j = f;
          }
        }
        e +=
          '<li id="' +
          n +
          u +
          '" class="' +
          c +
          '"><a href="javascript:void(0);" onclick="' +
          m +
          '" title="' +
          f +
          '" target="_self"><span class="kuFilterLabel">' +
          j +
          '</span><span class="' +
          r +
          '">' +
          l +
          '</span></a></li><input type="hidden" id="' +
          d +
          '" value="' +
          klevu_commons.escapeHtml(a[n].value) +
          '"/>';
      }
      e += "</ul></div></div>";
      if (a.length > 6) {
        if (q) {
          e = e.replace('<div class="kuFilterBox ' + b + '" id="kuFilterBox-' + u + '">', '<div class="kuFilterBox kuFilterBoxmore ' + b + '" style="height:auto;" id="kuFilterBox-' + u + '">');     
        } else {
          e = e.replace('<div class="kuFilterBox ' + b + '" id="kuFilterBox-' + u + '">', '<div class="kuFilterBox kuFilterBoxmore ' + b + '" style="height:auto;" id="kuFilterBox-' + u + '">');
        }
      } else {
      	
      }
      klevuLandingFilterTxt += e;
      if (a.length > 0 && a.length < 6) {
        return "kuFilterBox-" + u;
      }
    }
  },
  displayPricingSlider: function () {
    var b = klevu_translateFilterLabel("PRICE RANGE").toUpperCase(),
      f = "",
      e = 1,
      l = "Price-Range",
      j,
      g = 0,
      h,
      d,
      n,
      o,
      m,
      a,
      k,
      c = "klevuPriceRangeSlider";
    if (e.length > 6) {
      f += '<div class="kuFilterBox" id="kuFilterBox-' + l + '">';
    } else {
      f += '<div class="kuFilterBox" style="height:auto;" id="kuFilterBox-' + l + '">';
    }
    f +=
      '<div class="kuFilterHead kuCollapse" id="kuFilterHead-' +
      l +
      '" onclick="klevu_landingFilters.collapseExpand( \'kuFilterHead-' +
      l +
      "', 'kuFilterNames-" +
      l +
      "', 'kuShowOpt-" +
      l +
      "', 'kuHideOpt-" +
      l +
      "', 'kuFilterBox-" +
      l +
      "' );\">" +
      b +
      '</div><div class="kuFilterNames kuFilterNames2" id="kuFilterNames-' +
      l +
      '">';
    if ("undefined" !== typeof klevu_current_version && klevu_current_version) {
      klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, "2.0.2");
      if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
        c = "kuPriceRangeSlider";
      }
      klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, "2.0.0");
      if (!isNaN(klevuPluginVersion) && klevuPluginVersion < 0) {
        klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, "1.2.5");
        if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
          c = "kuPriceRangeSlider";
        }
      }
    }
    if ("undefined" !== typeof klevu_shopifyStore && klevu_shopifyStore) {
      c = "kuPriceRangeSlider";
    }
    f += '<div class="' + c + '"><div id="ku-price-range"></div>';
    f += '<div > <span id="ku-from-price"></span>&nbsp; <span id="ku-to-price"></span></div></div>';
    f += "</div></div>";
    return f;
  },
  sendQuery: function (h, d) {
    var e,
      l = document,
      k = "",
      j = "",
      f = l.getElementById("kuFilters"),
      b,
      a = "";
    if (d) {
      l.getElementById(h.split("~")[0]).className = "kuSelected";
    }
    if ("undefined" !== typeof klevu_userFilterResults) {
      j = klevu_userFilterResults;
    }
    b = getElementsByClassName("kuSelected", "li");
    e = "";
    for (var c = 0, g = b.length; c < g; c++) {
      k = klevu_commons.unescapeHtml(l.getElementById(b[c].id + "~text").value);
      if (j.indexOf(k) !== -1) {
        continue;
      }
      if (e.trim() === "") {
        e += k;
      } else {
        e += ";;" + k;
      }
    }
    if ("undefined" !== typeof klevu_showPriceSlider && klevu_showPriceSlider && klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
      a = ";;" + klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0];
    }
    klevu_userOptions.selectedLandingFilters = e + a;
    if (klevu_addSelectedFiltersToUrl) {
      klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingFilters, klevu_productFilterParam);
    }
    klevu_pagination.landingStartPosition = 0;
    if ("undefined" === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    if (l.getElementById("kuProductContent")) {
      l.getElementById("kuProductContent").style.opacity = "0.3";
    }
    klevu_landingFilters.loadingFiltersFor = "filter-selection";
    klevu_search.fetchResults(l.getElementById("searchedKeyword").value, "klp");
    return false;
  },
  showAll: function (d, c) {
    var e = document,
      b = e.getElementById(d),
      a = d.substring(d.indexOf("-") + 1, d.length);
    b.style.height = "auto";
    b.style.overflow = "visible";
    e.getElementById("kuShowOpt-" + a).style.display = "none";
    e.getElementById("kuHideOpt-" + a).style.display = "block";
  },
  hideAll: function (c) {
    var d = document,
      b = d.getElementById(c),
      a = c.substring(c.indexOf("-") + 1, c.length);
    b.style.height = "";
    b.style.overflow = "hidden";
    d.getElementById("kuShowOpt-" + a).style.display = "block";
    d.getElementById("kuHideOpt-" + a).style.display = "none";
  },
  showSelectedFilter: function (g, k, e, f, a) {
    var j = document,
      c = j.getElementById("ku-search-filter-tags"),
      h = j.getElementById("kuClearAllFilters"),
      d = "",
      b = "";
    if (c) {
      if (e === -1) {
        c.innerHTML = "";
        return;
      }
      if (e === 0) {
        c.innerHTML = "";
      }
      if (f) {
        d = f + " : ";
      }
      if (undefined !== typeof a && a === "Price-Range") {
        if (!j.getElementById("kuPriceRangeTag")) {
          k = k.split(":")[1];
          d = klevu_translateFilterLabel("PRICE RANGE").toUpperCase() + " : ";
          c.innerHTML += '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> ' + d + k + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); " target="_self" href="#">x</a></span> ';
        }
      } else {
        c.innerHTML += '<span class="ku-search-filter-tag"> ' + d + k + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelFilter(\'' + g + '\'); " target="_self" href="#">x</a></span> ';
      }
      if (j.getElementById("kuClearAllFilters")) {
        j.getElementById("kuClearAllFilters").parentNode.removeChild(j.getElementById("kuClearAllFilters"));
      }
      c.innerHTML +=
        '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); " onkeydown="klevu_eventHandler.handleElementKeydownEvent(event, null, klevu_landingFilters.clearAllFilters);" tabindex="0"><a> ' +
        klevu_uiLabels.clearAll +
        "</a></span>";
    }
  },
  cancelFilter: function (a) {
    document.getElementById(a.split("~")[0]).className = "";
    klevu_landingFilters.sendQuery(a, false);
  },
  cancelPriceSliderFilter: function () {
    klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, "");
    klevu_landingFilters.sendQuery("", false);
  },
  clearAllFilters: function () {
    var b = getElementsByClassName("kuSelected", "li");
    for (var c = 0, a = b.length; c < a; c++) {
      b[c].className = "";
    }
    if (document.getElementById("kuPriceRangeTag")) {
      klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, "");
    }
    klevu_landingFilters.sendQuery("", false);
  },
  collapseExpand: function (h, b, e, j, d) {
    var i = document,
      g = i.getElementById(h),
      a = i.getElementById(b),
      k = i.getElementById(e),
      c = i.getElementById(j),
      f = i.getElementById(d);
    if (g.className.indexOf("kuCollapse") !== -1) {
      g.className = "kuFilterHead kuExpand";
      a.style.display = "none";
      if (k) {
        k.style.display = "none";
      }
      if (c) {
        c.style.display = "none";
      }
      klevu_landingFilters.filterHeight = f.style.height;
      f.style.height = "50px";
    } else {
      if (g.className.indexOf("kuExpand") !== -1) {
        g.className = "kuFilterHead kuCollapse";
        a.style.display = "block";
        if (k) {
          k.style.display = "block";
        }
        if (c) {
          c.style.display = "none";
        }
        if (k && c) {
          klevu_landingFilters.hideAll(d);
        } else {
          f.style.height = "auto";
        }
      }
    }
  },
  showFiltersOnMobile: function (f) {
    var g = document,
      d = g.getElementById("kuFilters"),
      b = g.getElementById("kuFilterRefineMobile");
    f = typeof f !== "undefined" ? f : true;
    if (b.className.indexOf("kuCollapse") !== -1) {
      if (f) {
        b.className = "kuFilterRefineMobile kuExpand";
        d.style.cssText += ";display : none !important;";
      } else {
        d.style.cssText += ";display : block !important;";
      }
    } else {
      if (b.className.indexOf("kuExpand") !== -1) {
        if (f) {
          b.className = "kuFilterRefineMobile kuCollapse";
          d.style.cssText += ";display : block !important;";
        } else {
          d.style.cssText += ";display : none !important;";
        }
        var e = getElementsByClassName("kuFilterHead", "div");
        for (var c = 0, a = e.length; c < a; c++) {
          if (e[c].className.indexOf("kuCollapse") !== -1) {
            e[c].click();
          }
        }
      }
    }
  },
};
var klevu_landingCmsFilters = {
  lastSelectedFilters: "",
  showFilters: function (a) {
    var g = document.getElementById("kuFilters"),
      h,
      l,
      e = 0,
      c = 0,
      b = new Array(),
      o = "",
      n = klevu_commons.isMobileDevice() ? document.getElementById("kuFilterRefineMobile") : document.getElementById("klevuNarrowByLabel");
    klevuLandingFilterTxt = "";
    g.innerHTML = "";
    if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
      o = " kuMulticheck";
    }
    if (a && a.length > 0) {
      g.className = "kuFilters kuCmsFilters " + o;
      for (h = 0, l = a.length; h < l; h++) {
        if (a[h].key === "Price Range") {
          continue;
        }
        b[e] = klevu_landingCmsFilters.displayFiltersData(a[h]);
        e++;
      }
      g.innerHTML = klevuLandingFilterTxt;
      if ("undefined" !== typeof n && n) {
        if (klevuLandingFilterTxt.trim().length === 0) {
          n.style.display = "none";
        } else {
          n.style.display = "block";
        }
      }
      for (h = 0, l = b.length; h < l; h++) {
        if (b[h] && b[h].trim() != "") {
          document.getElementById(b[h]).style.height = "auto";
        }
      }
      e = 0;
      for (c = 0, l = a.length; c < l; c++) {
        var p = a[c].key.replace(" ", "_"),
          f = a[c].options;
        for (var h = 0; h < f.length; h++) {
          var d = f[h].isSelected,
            m = h + p + "~text";
          if (d.trim() === "true") {
            klevu_landingCmsFilters.showSelectedFilter(m, f[h].name, e, a[c].label);
            e++;
          }
        }
      }
      if (e === 0) {
        klevu_landingCmsFilters.showSelectedFilter(null, null, -1);
      }
      g.style.display = "none";
      g.offsetHeight;
      g.style.display = "block";
      if (document.getElementById("kuFilterRefineMobile") && klevu_commons.isMobileDevice() && (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768)) {
        if (klevu_landingCmsFilters.lastSelectedFilters === klevu_userOptions.selectedLandingCmsFilters) {
          klevu_landingCmsFilters.showFiltersOnMobile(false);
        } else {
          klevu_landingCmsFilters.showFiltersOnMobile(!(e === 0));
        }
        klevu_landingCmsFilters.lastSelectedFilters = klevu_userOptions.selectedLandingCmsFilters;
      }
    } else {
      g.className = "kuFilters kuCmsFilters disableKuFilter" + o;
    }
  },
  displayFiltersData: function (c) {
    if (c) {
      var d = klevu_translateFilterLabel(c.label),
        h = "",
        g = c.options,
        n = c.key.replace(" ", "_"),
        b = false,
        m = "",
        j = "kuHover";
      if (klevu_commons.isMobileDevice) {
        j = "";
      }
      if (g.length > 6) {
        h += '<div class="kuFilterBox ' + j + '" id="kuFilterBox-' + n + '">';
      } else {
        h += '<div class="kuFilterBox ' + j + '" style="height:auto;" id="kuFilterBox-' + n + '">';
      }
      h +=
        '<div class="kuFilterHead kuCollapse" id="kuFilterHead-' +
        n +
        '" onclick="klevu_landingCmsFilters.collapseExpand( \'kuFilterHead-' +
        n +
        "', 'kuFilterNames-" +
        n +
        "', 'kuShowOpt-" +
        n +
        "', 'kuHideOpt-" +
        n +
        "', 'kuFilterBox-" +
        n +
        "' );\">" +
        d +
        '</div><div class="kuFilterNames kuFilterNames3" id="kuFilterNames-' +
        n +
        '"><ul>';
      for (var f = 0, k = g.length; f < k; f++) {
        var e = g[f].isSelected,
          l = f + n + "~text",
          p = "",
          q = "kuFilterTotal",
          o = g[f].count,
          a = "klevu_landingCmsFilters.sendQuery('" + l + "', true );";
        if (e.trim() === "true") {
          p = "kuSelected";
          q = "kuFilterCancel";
          if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
            o = g[f].count;
            b = true;
          } else {
            o = "X";
          }
          a = "klevu_landingCmsFilters.cancelFilter('" + l + "'); ";
        }
        if (klevu_userOptions.truncateFilterLabel) {
          m = g[f].name.trunc(18);
        } else {
          m = g[f].name;
        }
        h +=
          '<li id="' +
          f +
          n +
          '" class="' +
          p +
          '"><a href="javascript:void(0);" onclick="' +
          a +
          '" title="' +
          g[f].name +
          '" target="_self"><span class="kuFilterLabel">' +
          m +
          '</span><span class="' +
          q +
          '">' +
          o +
          '</span></a></li><input type="hidden" id="' +
          l +
          '" value="' +
          klevu_commons.escapeHtml(g[f].value) +
          '"/>';
      }
      h += "</ul></div></div>";
      if (g.length > 6) {
        if (b) {
          h = h.replace('<div class="kuFilterBox ' + j + '" id="kuFilterBox-' + n + '">', '<div class="kuFilterBox ' + j + '" style="height:auto;" id="kuFilterBox-' + n + '">');
        } else {
          h +=
            '<div class="kuShowOpt" id="kuShowOpt-' +
            n +
            '" style="display:block;text-align:center;"><a href="javascript:klevu_landingCmsFilters.showAll( \'kuFilterBox-' +
            n +
            '\' );" title="' +
            klevu_uiLabels.showMore +
            '" target="_self"><img src="' +
            klevu_userOptions.viewMoreImageUrl +
            '" alt="' +
            klevu_uiLabels.showMore +
            '"/></a></div><div class="kuHideOpt" id="kuHideOpt-' +
            n +
            '" style="display:none;text-align:center;"><a href="javascript:void(0);" onclick="klevu_landingCmsFilters.hideAll(\'kuFilterBox-' +
            n +
            '\');" title="' +
            klevu_uiLabels.showLess +
            '" target="_self"><img src="' +
            klevu_userOptions.viewLessImageUrl +
            '" alt="' +
            klevu_uiLabels.showLess +
            '"/></a></div>';
        }
      }
      klevuLandingFilterTxt += h;
      if (g.length > 0 && g.length < 6) {
        return "kuFilterBox-" + n;
      }
    }
  },
  sendQuery: function (e, h) {
    var d,
      g = document,
      c = g.getElementById("kuFilters"),
      b;
    if (h) {
      g.getElementById(e.split("~")[0]).className = "kuSelected";
    }
    b = getElementsByClassName("kuSelected", "li");
    d = "";
    for (var f = 0, a = b.length; f < a; f++) {
      if (d.trim() === "") {
        d += klevu_commons.unescapeHtml(g.getElementById(b[f].id + "~text").value);
      } else {
        d += ";;" + klevu_commons.unescapeHtml(g.getElementById(b[f].id + "~text").value);
      }
    }
    klevu_userOptions.selectedLandingCmsFilters = d;
    if (klevu_addSelectedFiltersToUrl) {
      klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingCmsFilters, klevu_cmsFilterParam);
    }
    klevu_pagination.landingCmsStartPosition = 0;
    if ("undefined" === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    g.getElementById("kuOtherContent").style.opacity = "0.3";
    klevu_search.fetchCmsResults(g.getElementById("searchedKeyword").value, "klp");
    return false;
  },
  showAll: function (c, b) {
    var d = document,
      a = d.getElementById(c);
    a.style.height = "auto";
    a.style.overflow = "visible";
    d.getElementById("kuShowOpt-" + c.split("-")[1]).style.display = "none";
    d.getElementById("kuHideOpt-" + c.split("-")[1]).style.display = "block";
  },
  hideAll: function (b) {
    var c = document,
      a = c.getElementById(b);
    a.style.height = "";
    a.style.overflow = "hidden";
    c.getElementById("kuShowOpt-" + b.split("-")[1]).style.display = "block";
    c.getElementById("kuHideOpt-" + b.split("-")[1]).style.display = "none";
  },
  showSelectedFilter: function (a, e, d, f) {
    var h = document,
      c = h.getElementById("ku-search-filter-tags"),
      b = h.getElementById("kuClearAllFilters"),
      g = "";
    if (c) {
      if (d === -1) {
        c.innerHTML = "";
        return;
      }
      if (d === 0) {
        c.innerHTML = "";
      }
      if (f) {
        g = f + " : ";
      }
      c.innerHTML += '<span class="ku-search-filter-tag"> ' + g + e + ' <a class="ku-search-filter-remove" onclick="klevu_landingCmsFilters.cancelFilter(\'' + a + '\'); " target="_self" href="#">x</a></span> ';
      if (h.getElementById("kuClearAllFilters")) {
        h.getElementById("kuClearAllFilters").parentNode.removeChild(h.getElementById("kuClearAllFilters"));
      }
      c.innerHTML +=
        '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingCmsFilters.clearAllFilters(); " onkeydown="klevu_eventHandler.handleElementKeydownEvent(event, null, klevu_landingCmsFilters.clearAllFilters);" tabindex="0"><a> ' +
        klevu_uiLabels.clearAll +
        "</a></span>";
    }
  },
  cancelFilter: function (a) {
    document.getElementById(a.split("~")[0]).className = "";
    klevu_landingCmsFilters.sendQuery(a, false);
  },
  clearAllFilters: function () {
    var b = getElementsByClassName("kuSelected", "li");
    for (var c = 0, a = b.length; c < a; c++) {
      b[c].className = "";
    }
    klevu_landingCmsFilters.sendQuery("", false);
  },
  collapseExpand: function (h, b, e, j, d) {
    var i = document,
      g = i.getElementById(h),
      a = i.getElementById(b),
      k = i.getElementById(e),
      c = i.getElementById(j),
      f = i.getElementById(d);
    if (g.className.indexOf("kuCollapse") !== -1) {
      g.className = "kuFilterHead kuExpand";
      a.style.display = "none";
      if (k) {
        k.style.display = "none";
      }
      if (c) {
        c.style.display = "none";
      }
      klevu_landingFilters.filterHeight = f.style.height;
      f.style.height = "50px";
    } else {
      if (g.className.indexOf("kuExpand") !== -1) {
        g.className = "kuFilterHead kuCollapse";
        a.style.display = "block";
        if (k) {
          k.style.display = "block";
        }
        if (c) {
          c.style.display = "none";
        }
        if (k && c) {
          klevu_landingFilters.hideAll(d);
        } else {
          f.style.height = "auto";
        }
      }
    }
  },
  showFiltersOnMobile: function (f) {
    var g = document,
      d = g.getElementById("kuFilters"),
      b = g.getElementById("kuFilterRefineMobile");
    f = typeof f !== "undefined" ? f : true;
    if (b.className.indexOf("kuCollapse") !== -1) {
      if (f) {
        b.className = "kuFilterRefineMobile kuExpand";
        d.style.cssText += ";display : none !important;";
      } else {
        d.style.cssText += ";display : block !important;";
      }
    } else {
      if (b.className.indexOf("kuExpand") !== -1) {
        if (f) {
          b.className = "kuFilterRefineMobile kuCollapse";
          d.style.cssText += ";display : block !important;";
        } else {
          d.style.cssText += ";display : none !important;";
        }
        var e = getElementsByClassName("kuFilterHead", "div");
        for (var c = 0, a = e.length; c < a; c++) {
          if (e[c].className.indexOf("kuCollapse") !== -1) {
            e[c].click();
          }
        }
      }
    }
  },
};
function klevu_setKuView(a) {
  var b = document;
  if (a === "list") {
    b.getElementById("kuResultsView").className = "kuListView";
    b.getElementById("listViewBtn").className += " kuCurrent";
    b.getElementById("gridViewBtn").className = "kuGridviewBtn";
  } else {
    if (a === "grid") {
      b.getElementById("kuResultsView").className = "kuGridView";
      b.getElementById("gridViewBtn").className += " kuCurrent";
      b.getElementById("listViewBtn").className = "kuListviewBtn";
    }
  }
}
function setKuView(a) {
  klevu_setKuView(a);
}
function klevu_changeKuTab(c) {
  var d = document,
    b = d.getElementById("searchedKeyword").value,
    a = "";
  if ("undefined" !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
    a = " kuMulticheck";
  }
  if (c === "product") {
    d.getElementById("kuProductContent").style.display = "block";
    d.getElementById("kuOtherContent").style.display = "none";
    if (d.getElementById("kuProductTab")) {
      d.getElementById("kuProductTab").className = "kuTabSelected";
    }
    if (d.getElementById("kuOtherTab")) {
      d.getElementById("kuOtherTab").className = "";
    }
    if (d.getElementById("kuFilters")) {
      d.getElementById("kuFilters").className = "kuFilters" + a;
    }
    d.getElementById("kuPagination1").style.display = "block";
    if (d.getElementById("kuPagination3")) {
      d.getElementById("kuPagination3").style.display = "none";
    }
    klevu_cmsTabEnabled = false;
    klevu_pagination.landingStartPosition = 0;
    if (klevu_addSelectedFiltersToUrl) {
      klevu_commons.addSelectedFiltersToPageUrl("", klevu_cmsFilterParam);
      klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingFilters, klevu_productFilterParam);
    }
    klevu_search.fetchResults(b, "klp");
  } else {
    if (c === "other") {
      d.getElementById("kuProductContent").style.display = "none";
      d.getElementById("kuOtherContent").style.display = "block";
      if (d.getElementById("kuProductTab")) {
        d.getElementById("kuProductTab").className = "";
      }
      if (d.getElementById("kuOtherTab")) {
        d.getElementById("kuOtherTab").className = "kuTabSelected";
      }
      if (d.getElementById("kuFilters")) {
        d.getElementById("kuFilters").className = "kuFilters disableKuFilter" + a;
      }
      if (d.getElementById("kuPagination1")) {
        d.getElementById("kuPagination1").style.display = "none";
      }
      d.getElementById("kuPagination3").style.display = "block";
      klevu_cmsTabEnabled = true;
      klevu_pagination.landingCmsStartPosition = 0;
      if (klevu_addSelectedFiltersToUrl) {
        klevu_commons.addSelectedFiltersToPageUrl("", klevu_productFilterParam);
        klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingCmsFilters, klevu_cmsFilterParam);
      }
      if (klevu_addPageNumberToUrl) {
        klevu_commons.addPageNumberToPageUrl("", klevu_productPageParam);
      }
      klevu_search.fetchCmsResults(b, "klp");
    }
  }
}
function klevu_landingAutoScroll() {
  var a = document.getElementById("kuProductContent");
  var c = 0;
  if (typeof pageYOffset != "undefined") {
    c = pageYOffset;
  } else {
    var d = document.body;
    var b = document.documentElement;
    b = b.clientHeight ? b : d;
    c = b.scrollTop;
  }
  if (a && c >= a.offsetHeight - Math.floor(a.offsetHeight / 3)) {
    if (klevu_searchedTerm.trim().length > 0) {
      if (klevu_userOptions.cmsEnabled) {
        if (klevu_cmsTabEnabled) {
          klevu_search.fetchCmsResults(klevu_searchedTerm, "klp");
        } else {
          klevu_landingFilters.loadingFiltersFor = "search-query";
          klevu_search.fetchResults(klevu_searchedTerm, "klp");
        }
      } else {
        klevu_landingFilters.loadingFiltersFor = "search-query";
        klevu_search.fetchResults(klevu_searchedTerm, "klp");
      }
    }
  }
}
function klevu_lpAutoScrollLoader(a) {
  var b = document;
  if (a === "show") {
    b.getElementById("kuLandingProductsListUl").innerHTML +=
      '<li id="kuAsLoader" style="width:100%;border:none;"><img style="width:initial;position:initial;" src="https://js.klevu.com/klevu-js-v2/img-1-1/ku-loader.gif" alt="Loading..."/></li>';
  } else {
    setTimeout(function () {
      if (b.getElementById("kuAsLoader")) {
        b.getElementById("kuAsLoader").parentNode.removeChild(b.getElementById("kuAsLoader"));
      }
    }, 200);
  }
}
function klevu_displayNoResultData(m) {
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.showLandingPageNoResultData) {
    return klevu_uc.showLandingPageNoResultData(m);
  }
  var n = "",
    l = 33,
    k = m.products || [],
    j = klevu_userOptions.noResultsOptions,
    c = false,
    d,
    a = document.createElement("div");
  n += '<div class="kuNoResults-lp">';
  n += '<div class="kuNoResultsInner">';
  n += '<div class="kuNoResults-lp-message" aria-live="assertive" role="status" tabindex="0">' + m.msgToShow + "</div>";
  if (k && k.length > 0) {
    n += '<div class="kuNoResults-lp-relatedProducts">';
    n += '<h3 class="kuNoResults-lp-title">' + m.headingForNoResultProducts + "</h3>";
    n += '<ul class="kuNoResults-lp-relatedProduct-list">';
    for (var f = 0; f < k.length; f++) {
      n += "<li>";
      n += '<a href="' + k[f].url + '" class="kuRelatedProductbox-lp"';
      if (klevu_commons.isMobileDevice()) {
        n += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + m.trackingParams[f] + ');" target="_self" >';
      } else {
        n +=
          ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' +
          m.trackingParams[f] +
          ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
          m.trackingParams[f] +
          ', klevu_analytics.trackClickedProduct);" ' +
          m.additionalParams +
          " >";
      }
      if (("undefined" === typeof klevu_truncateDescription || ("undefined" !== typeof klevu_truncateDescription && klevu_truncateDescription)) && k[f].desc.length > l) {
        k[f].desc = k[f].desc.replace(/^(.{33}[^\s]*).*/, "$1") + " ...";
      }
      a.innerHTML = k[f].name;
      d = a.textContent || a.innerText || "";
      n += '<div class="kuNoResultsImgWrap-lp">';
      n += '<img src="' + k[f].imageUrl + '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(d) + '"/></div>';
      n += '<div class="kuProduct-desc">';
      n += '<div class="ku-name">' + k[f].name + "</div>";
      n += '<div class="ku-desc">' + k[f].desc + "</div>";
      n += "</div>";
      if (klevu_showPrices) {
        n += '<div class="kuPrice">';
        if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
          n += klevu_commons.showOriginalAndSalePrices("LANDING", k[f], "kuSalePrice", "kuSalePrice kuSpecialPrice");
        } else {
          n += klevu_commons.showProductPrices("LANDING", k[f], "kuSalePrice", "kuSalePrice kuSpecialPrice");
        }
        n += "</div>";
      }
      if (k[f].totalProductVariants && k[f].totalProductVariants != "0") {
        n += '<div class="kuVariants">+' + k[f].totalProductVariants + " " + klevu_uiLabels.variants + "</div>";
      }
      n += '<div class="klevu-clear-left"></div>';
      n += "</a> </li>";
    }
    n += "</ul>";
    n += "</div>";
  }
  if (m.banner && m.banner.showOnLandingPage) {
    trackingParams = "{id: '" + m.banner.bannerRef + "',name: '" + m.banner.bannerName + "',image: '" + escape(m.banner.bannerImageUrl) + "',redirectUrl: '" + m.banner.redirectUrl + "'}";
    if (klevu_commons.isMobileDevice()) {
      trackingEvent = " onclick=";
    } else {
      trackingEvent = ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedBannerAds);"  onmousedown=';
    }
    trackingEvent += '"return klevu_analytics.trackClickedBannerAds(event, ' + trackingParams + ');" target="_blank">';
    n += '<div class="kuNoResults-lp-banner"><a href="' + m.banner.redirectUrl + '" ' + trackingEvent + '<img src="' + m.banner.bannerImageUrl + '" alt="' + m.banner.bannerName + '"/></a></div>';
  }
  if ((j && j.showPopularKeywords) || klevu_userOptions.showPopularKeywordsForNoResult) {
    c = true;
  }
  if ("undefined" !== typeof klevu_webstorePopularTerms && klevu_webstorePopularTerms && c) {
    var b = klevu_webstorePopularTerms,
      g = 1;
    n += '<div class="kuNoResults-lp-pSearch">';
    n += '<strong class="kuNoResults-lp-pSearch-title">' + klevu_uiLabels.popularSearches + " </strong>";
    if (b && b.length > 0) {
      for (f = 0; f < b.length; f++) {
        if (f !== 0) {
          n += ", ";
        }
        try {
          n += '<a href="' + m.landingPageUrl + encodeURIComponent(decodeURIComponent(b[f])) + '" target="_self">' + decodeURIComponent(b[f]) + "</a>";
        } catch (h) {
          continue;
        }
        if (g === 5) {
          break;
        }
        g++;
      }
    }
    n += "</div>";
  }
  n += "</div>";
  n += "</div>";
  return n;
}
function klevu_pageLoadEvent() {
  if (typeof klevu_search !== "undefined" && typeof klevu_search.fetchResults !== "undefined" && typeof klevu_layout !== "undefined" && typeof klevu_storeSearchBoxes !== "undefined" && document.getElementById("searchedKeyword")) {
    if (document.getElementById("kuProListing")) {
      var b = document.getElementById("kuProListing").querySelectorAll("select");
      for (var c = 0, a = b.length; c < a; c++) {
        b[c].style.height = "auto";
      }
    }
    klevu_getSearchResults();
  } else {
    setTimeout(klevu_pageLoadEvent, 100);
  }
}
klevu_pageLoadEvent();
function klevu_getSearchResults() {
  var t = document,
    l = "undefined" !== typeof klevu_pageCategory ? "*" : t.getElementById("searchedKeyword").value,
    e = t.getElementById("noOfRecords"),
    d = t.getElementById("layoutView"),
    b = klevu_getParamValue(klevu_productFilterParam) || klevu_getParamValue("klevu_fp"),
    o = klevu_getParamValue(klevu_cmsFilterParam) || klevu_getParamValue("klevu_fc"),
    h = "undefined" !== typeof klevu_rangeFilterParam ? klevu_getParamValue(klevu_rangeFilterParam) : null,
    m = 0,
    s,
    f = true,
    a = "undefined" !== typeof klevu_pageCategory ? " kuCategoryPage" : "";
  if (l !== "*" && (l.trim().length < klevu_userOptions.minimumLetters || l === "undefined")) {
    klevu_lpZeroResults = 2;
    klevu_lpHandleNoResultsOrInvalidTermLength(klevu_uiLabels.minimumLtrText, null);
    return false;
  }
  klevu_lpZeroResults = 0;
  for (m = 0; m < klevu_storeSearchBoxes.length; m++) {
    if (klevu_storePlaceholders[m] === l) {
      klevu_storePlaceholders[m] = "";
    }
    if ("undefined" === typeof klevu_setTermInSearchBox || klevu_setTermInSearchBox) {
      klevu_storeSearchBoxes[m].value = l !== "*" ? l : "";
    }
  }
  klevu_activeSearchBox = klevu_storeSearchBoxes[0];
  klevu_searchedTerm = l;
  if (!klevu_showPrices) {
    t.getElementById("kuSortby").parentNode.style.display = "none";
  } else {
    s = t.getElementById("kuSortby").options;
    if (s.length === 3) {
      s[0].value = "rel";
      s[1].value = "lth";
      s[2].value = "htl";
    }
    t.getElementById("kuSortby").value = "rel";
  }
  if (t.getElementById("klevuSortLbl")) {
    t.getElementById("klevuSortLbl").setAttribute("for", "kuSortby");
  }
  if (t.getElementById("klevuItemsPerPage")) {
    t.getElementById("klevuItemsPerPage").setAttribute("for", "noOfRecords1");
  }
  if (t.getElementById("klevuItemsPerPageFooter")) {
    t.getElementById("klevuItemsPerPageFooter").setAttribute("for", "noOfRecords2");
  }
  if (t.getElementById("klevuItemsPerPageCms")) {
    t.getElementById("klevuItemsPerPageCms").setAttribute("for", "noOfRecords3");
  }
  if (t.getElementById("klevuItemsPerPageCmsFooter")) {
    t.getElementById("klevuItemsPerPageCmsFooter").setAttribute("for", "noOfRecords4");
  }
  if (t.getElementById("gridViewBtn")) {
    t.getElementById("gridViewBtn").href = "#";
  }
  if (t.getElementById("listViewBtn")) {
    t.getElementById("listViewBtn").href = "#";
  }
  klevu_userOptions.selectedLandingFilters = "";
  klevu_userOptions.selectedLandingRangeFilters = "";
  klevu_userOptions.sortingLandingValue = "rel";
  klevu_pagination.landingRecordsPerPage = e ? e.value : klevu_userOptions.recordsPerPage;
  klevu_pagination.landingStartPosition = klevu_userOptions.paginationStartFrom;
  klevu_pagination.totalLandingResultsFound = 0;
  if (t.getElementById("noOfRecords1")) {
    t.getElementById("noOfRecords1").value = klevu_pagination.landingRecordsPerPage;
  }
  if (t.getElementById("noOfRecords2")) {
    t.getElementById("noOfRecords2").value = klevu_pagination.landingRecordsPerPage;
  }
  if (klevu_userOptions.cmsEnabled) {
    klevu_userOptions.selectedLandingCmsFilters = "";
    klevu_pagination.landingCmsRecordsPerPage = e ? e.value : klevu_userOptions.recordsPerPage;
    klevu_pagination.landingCmsStartPosition = klevu_userOptions.paginationStartFrom;
    klevu_pagination.totalLandingCmsResultsFound = 0;
    if (t.getElementById("noOfRecords3")) {
      t.getElementById("noOfRecords3").value = klevu_pagination.landingCmsRecordsPerPage;
    }
    if (t.getElementById("noOfRecords4")) {
      t.getElementById("noOfRecords4").value = klevu_pagination.landingCmsRecordsPerPage;
    }
  }
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.landingFilters) {
    for (var q in klevu_uc.landingFilters) {
      if (klevu_uc.landingFilters.hasOwnProperty(q)) {
        klevu_landingFilters[q] = klevu_uc.landingFilters[q];
      }
    }
  }
  if ("undefined" !== typeof klevu_uc && "undefined" !== typeof klevu_uc.landingCmsFilters) {
    klevu_landingCmsFilters = klevu_uc.landingCmsFilters;
  }
  if ("undefined" != typeof d && d) {
    klevu_setKuView(d.value);
  } else {
    klevu_setKuView("grid");
  }
  if (klevu_enableLandingAutoScroll) {
    var r = getElementsByClassName("kuPerPage", "div");
    for (var m = 0, n = r.length; m < n; m++) {
      r[m].style.display = "none";
    }
    klevu_commons.attachEvent(window, "scroll", klevu_landingAutoScroll);
  }
  if ("undefined" !== typeof klevu_showBannerAds && klevu_showBannerAds && !t.getElementById("klevuBannerAdLanding")) {
    var p = t.createElement("div");
    p.id = "klevuBannerAdLanding";
    p.className = "kuBannerAd";
    if (t.getElementById("kuMainContainer")) {
      t.getElementById("kuMainContainer").insertBefore(p, t.getElementById("kuMainContainer").firstElementChild);
    } else {
      if (t.getElementById("kuProListing")) {
        t.getElementById("kuProListing").insertBefore(p, t.getElementById("kuFilters"));
      }
    }
  }
  if ("undefined" !== typeof klevu_similarProductsFoundMsg && klevu_similarProductsFoundMsg && !t.getElementById("kuOrQueryMessage")) {
    var c = t.createElement("div");
    c.id = "kuOrQueryMessage";
    c.className = "kuOrQueryMessage";
    if (t.getElementById("kuProListing")) {
      t.getElementById("kuProListing").insertBefore(c, t.getElementById("kuFilters"));
    }
  }
  klevu_userOptions.fetchFilters = true;
  if (!t.getElementById("kuMainContainer")) {
    klevu_userOptions.showFiltersInMobile = false;
  }
  if (klevu_commons.isMobileDevice() && (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768)) {
    var g = t.getElementById("kuFilterRefineMobile");
    if (!g && klevu_userOptions.showFiltersInMobile) {
      g = t.createElement("div");
      g.id = "kuFilterRefineMobile";
      g.className = "kuFilterRefineMobile kuExpand";
      g.onclick = klevu_landingFilters.showFiltersOnMobile;
      g.innerHTML = '<span class="KuFilterLabelTxt">' + klevu_uiLabels.narrowBy + "</span>";
      if (t.getElementById("kuProListing")) {
        t.getElementById("kuProListing").insertBefore(g, t.getElementById("kuFilters"));
      }
    } else {
      if (!klevu_userOptions.showFiltersInMobile) {
        klevu_userOptions.fetchFilters = false;
      }
    }
  }
  if (!t.getElementById("kuMainContainer")) {
    klevu_userOptions.fetchFilters = true;
  }
  var k = t.getElementById("ku-search-filter-tags");
  if (!k && t.getElementById("kuMainContainer")) {
    k = t.createElement("div");
    k.id = "ku-search-filter-tags";
    if (t.getElementById("kuProListing")) {
      t.getElementById("kuProListing").insertBefore(k, t.getElementById("kuFilters"));
    }
  }
  if (t.getElementById("kuProListing")) {
    if ("undefined" !== typeof klevu_userOptions.landingFilterPosition && klevu_userOptions.landingFilterPosition === "top" && !klevu_commons.isMobileDevice()) {
      t.getElementById("kuProListing").parentNode.className = "kuContainer kuFiltersTop" + a;
      f = false;
    } else {
      t.getElementById("kuProListing").parentNode.className = "kuContainer kuFiltersLeft" + a;
      f = true;
    }
  }
  if (t.getElementById("ku-search-form")) {
    if ("undefined" !== typeof klevu_userOptions.showSearchBoxOnLandingPage && klevu_userOptions.showSearchBoxOnLandingPage) {
      t.getElementById("ku-search-form").style.display = "block";
    } else {
      t.getElementById("ku-search-form").style.display = "none";
      if (f && t.getElementById("klevuNarrowByLabel")) {
        t.getElementById("klevuNarrowByLabel").style.marginTop = "0px";
      }
    }
  }
  if ("undefined" !== typeof klevu_pageCategory && klevu_pageCategory) {
    var j = t.createElement("textarea");
    j.innerHTML = klevu_pageCategory;
    klevu_pageCategory = j.value;
  }
  if (klevu_addSelectedFiltersToUrl) {
    if ("undefined" !== typeof h && h) {
      klevu_userOptions.selectedLandingRangeFilters = h;
      if (klevu_userOptions.cmsEnabled) {
        klevu_changeKuTab("product");
      } else {
        klevu_search.fetchResults(l, "klp");
      }
    }
    if ("undefined" !== typeof b && b) {
      klevu_userOptions.selectedLandingFilters = b;
      if (klevu_userOptions.cmsEnabled) {
        klevu_changeKuTab("product");
      } else {
        klevu_search.fetchResults(l, "klp");
      }
    } else {
      if ("undefined" !== typeof o && o) {
        klevu_userOptions.selectedLandingCmsFilters = o;
        klevu_changeKuTab("other");
      } else {
        klevu_search.fetchResults(l, "klp");
      }
    }
  } else {
    klevu_search.fetchResults(l, "klp");
  }
}
